import axios from "axios";
import { apiAddress } from "../../config/server";
import * as types from "./actionTypes";

export const resetPasswordTokenType = "resetPassword";

function getTokenStarted(tokenId) {
  return { type: types.TOKEN_GET_STARTED, payload: tokenId };
}

function getTokenFulfilled(token) {
  return { type: types.TOKEN_GET_FULFILLED, payload: token };
}

function getTokenRejected(error, tokenId) {
  return {
    type: types.TOKEN_GET_REJECTED,
    payload: { message: error, tokenId },
  };
}

export function getToken(tokenId, type) {
  return (dispatch) => {
    dispatch(getTokenStarted(tokenId));
    axios
      .get(`${apiAddress}/api/token/${tokenId}/${type}`)
      .then((response) => {
        if (response.data && response.data.success) {
          dispatch(getTokenFulfilled(response.data.data));
        } else {
          dispatch(getTokenRejected(response.data.message, tokenId));
        }
      })
      .catch((er) => {
        dispatch(getTokenRejected(er.message, tokenId));
      });
  };
}
